<template>
  <div
    id="boardMeeting"
    class="boardmeeting"
  >
    <div
      id="announcementCont"
      v-if="announcement.show"
    >

      <b-notification
        id="announcement"
        closable
        :active.sync="announcement.show"
      >
        {{announcement.message}}
      </b-notification>
    </div>
    <b-modal
      :active.sync="isImageModalActive"
      @close="closeImageModal"
    >
      <img
        :src="this.ImageModalSrc"
        @click="closeImageModal"
      />
    </b-modal>
    <div id="positionning">
      <div id="fixingDiv">
        <div class="tools">
          <!-- <p id="backgroundString" style="display:none"></p> -->
          <div
            id="topHalf"
            v-if="!insideIframe"
            style="width: 100%;display: inherit;"
          >
            <div
              v-if="this.$router.currentRoute.name === 'animer' "
              style="margin-left: -10px;margin-right: 10px;"
            >
              <backToAdmin></backToAdmin>
            </div>
            <div class="title">
              <img src="~@/assets/public_logo.png" />
              <h1 class>{{ current.name }}</h1>
            </div>
            <div
              id="showToolbar"
              style="position:absolute;left:calc(100vw - 55px);color:white;"
              @click="setToolDisplay()"
            >
              <b-icon :icon="showTools? 'sort-up':'sort-down'"></b-icon>
            </div>
          </div>
          <span
            id="bottomHalf"
            v-if="showTools"
          >
            <div v-if="this.$router.currentRoute.name === 'animer'&& insideIframe ">
              <backToAdmin></backToAdmin>
            </div>

            <div
              class="leftMenu"
              v-if="(this.$router.currentRoute.name === 'animer' || current.mode === 'libre') && !boardIsClosed"
            >
              <b-tooltip
                type="is-primary"
                :label="$t('tooltip.freehand')"
                position="is-right"
              >
                <div
                  class=" leftMenuBtn"
                  style="margin-top:10px;"
                  id="drawingOnOff"
                  :class="{active : menu.drawing}"
                  @click="
                drawingOnOffClick()"
                >
                  <img
                    src="/static/emptyPencil.png"
                    alt="Pencil Icon"
                    class="iconPic"
                  >

                </div>
              </b-tooltip>
              <b-tooltip
                type="is-primary"
                :label="$t('tooltip.select')"
                position="is-right"
              >
                <div
                  class=" leftMenuBtn"
                  id="selectingOnOff"
                  style="margin-top:10px;"
                  :class="{active : menu.selecting}"
                  @click="
                selectingOnOffClick()"
                >
                  <img
                    src="/static/emptyGroup.png"
                    alt="Group Icon"
                    class="iconPic"
                  >

                </div>
              </b-tooltip>

              <b-tooltip
                type="is-primary"
                :label="$t('tooltip.linkHier')"
                position="is-right"
              >
                <div
                  class=" leftMenuBtn"
                  id="selectingOnOff"
                  style="margin-top:10px;"
                  :class="{active : menu.linkHier}"
                  @click="linkWithHierarchy()"
                >
                  <img
                    src="/static/lightArrow.png"
                    alt="Light Arrow Icon"
                    class="iconPic"
                  >

                </div>
              </b-tooltip>

              <b-tooltip
                type="is-primary"
                :label="$t('tooltip.linkSimple')"
                position="is-right"
              >
                <div
                  class=" leftMenuBtn"
                  id="selectingOnOff"
                  :class="{active : menu.linkSimple}"
                  @click="linkWithoutHierarchy()"
                >
                  <b-icon
                    icon="minus"
                    pack="fas"
                    class="leftIcon myIcons"
                    custom-size="null"
                    custom-class="innerIcons"
                  ></b-icon>
                </div>
              </b-tooltip>

              <b-tooltip
                type="is-primary"
                position="is-bottom"
                :label="$t('tooltip.erase')"
              >
                <div
                  class=" leftMenuBtn"
                  id="erasingOnOff"
                  style="margin-top:10px;"
                  :class="{active : menu.erasing}"
                  @click="erasingOnOffClick()"
                >
                  <img
                    src="/static/emptyEraser.png"
                    alt="Eraser Icon"
                    class="iconPic"
                  >

                </div>
              </b-tooltip>
              <b-tooltip
                type="is-primary"
                position="is-bottom"
                :label="$t('tooltip.text')"
              >
                <div
                  class=" leftMenuBtn"
                  id="writingOnOff"
                  style="margin-top:10px;"
                  @click="writingOnOffClick()"
                  :class="{active : menu.modeWriting}"
                >
                  <img
                    src="/static/lightLetter.png"
                    alt="Light Letter Icon"
                    class="iconPic"
                  >
                </div>
              </b-tooltip>
              <b-tooltip
                type="is-primary"
                position="is-top"
                :label="$t('tooltip.color')"
              >
                <div
                  class="drawingMenuBlock"
                  id="drawingColors"
                >
                  <div
                    id="currentColor"
                    :style='`background-color:${lineColor}; border: 2px solid white;`'
                    @click="showColorPicker"
                  ></div>
                  <div
                    id="colorPopupMenu"
                    v-show="colorPicking"
                  >
                    <div
                      v-if="typeof colors === 'object'"
                      v-for="(color, key) in colors"
                      :key="key"
                      :style="color === lineColor? 'border:2px solid black; box-sizing: border-box;margin:0px;height:24px':'border:none;margin: 1px;height:24px;'"
                    >
                      <div
                        class="colorBlock"
                        :style="`background-color:${color};`"
                        @click="changeColor(color)"
                      ></div>
                    </div>
                  </div>
                </div>
              </b-tooltip>
              <b-tooltip
                type="is-primary"
                :label="$t('tooltip.size')"
                position="is-bottom"
              >
                <div id="widthSetter">
                  <input
                    v-if="$refs.board"
                    type="number"
                    name="width"
                    id="width"
                    v-model="$refs.board.width"
                    min="3"
                    max="50"
                    @mouseout="()=>{$refs.board.width > 50 ? $refs.board.width = 50: null}"
                    @blur="()=>{$refs.board.width > 50 ? $refs.board.width = 50: null}"
                  />
                </div>
              </b-tooltip>
            </div>

            <div class="rightMenu">
              <div class="recherche">
                <input
                  v-model="recherche"
                  :placeholder="$t('placeholder.rechercher')"
                  type="search"
                > </input>
              </div>

              <div
                id="colorfilter"
                class="colorfilter"
              >
                <b-dropdown>
                  <template v-if="currentFilteredColor === null">
                    <button
                      class="filterButton"
                      style="border:2px solid white;height: 28px;"
                      slot="trigger"
                    >
                      <span class="filterByColorText">{{ $t('filter.color') }}</span>
                    </button>
                  </template>
                  <template v-else>
                    <button
                      class="filterButton"
                      :style="'background-color:'+currentFilteredColor+';color:black;border:2px solid #ffffff00;height: 28px;'"
                      slot="trigger"
                    >
                      <span
                        class="filterByColorText"
                        :style="currentFilteredColor ==='rgb(20,20,20)'? 'color:white;':''"
                      >{{ $t('filter.color') }}</span>
                    </button>
                  </template>
                  <b-dropdown-item @click="filterColor(null)">{{ $t('filter.reset') }}</b-dropdown-item>
                  <template
                    v-for="color in colors"
                    v-key="color"
                  >
                    <b-dropdown-item
                      v-bind:key="color"
                      @click="filterColor(color)"
                    >
                      <b-icon
                        pack="fas"
                        icon="square"
                        size="is-small"
                        :style="'color:'+color"
                      ></b-icon>
                    </b-dropdown-item>
                  </template>
                </b-dropdown>
              </div>

              <div
                @click="wordcloud"
                class="weirdFlex"
              >
                <b-tooltip
                  type="is-primary"
                  :label="$t('tooltip.wordcloud')"
                  position="is-left"
                >
                  <img
                    src="/static/nuage.png"
                    width='auto'
                    height="24"
                    class="iconPic"
                    id="nuagePic"
                  />
                </b-tooltip>
              </div>
              <div
                class="wordcloud weirdFlex"
                @click="pagelike"
              >
                <b-tooltip
                  type="is-primary"
                  :label="$t('tooltip.like')"
                  position="is-left"
                >
                  <img
                    src="/static/logo_aimer.png"
                    alt="Thumbup Icon"
                    class="iconPic"
                  >

                </b-tooltip>
              </div>
              <div
                class="wordcloud weirdFlex"
                @click="toggleInfos"
              >
                <b-tooltip
                  type="is-primary"
                  :label="$t('tooltip.information')"
                  position="is-left"
                >
                  <img
                    src="/static/emptyInfo.png"
                    alt="Info Icon"
                    class="iconPic"
                  >

                </b-tooltip>
              </div>
              <div
                @click="screeshot"
                class="wordcloud weirdFlex"
                id="screenshot"
              >
                <b-tooltip
                  type="is-primary"
                  :label="$t('tooltip.screeshot')"
                  position="is-left"
                >
                  <img
                    src="/static/emptyCamera.png"
                    alt="camera Icon"
                    class="iconPic"
                  >

                </b-tooltip>
              </div>
              <div
                v-if="!insideIframe"
                class="fullscreenswitch weirdFlex"
                @click="fullscreen"
              >
                <b-tooltip
                  type="is-primary"
                  :label="$t('tooltip.fullscreen')"
                  position="is-left"
                >
                  <img
                    src="/static/emptyExpand.png"
                    alt="Expand Icon"
                    class="iconPic"
                  >

                </b-tooltip>
              </div>
              <div
                class="fullscreenswitch weirdFlex"
                @click="showClock = !showClock"
                v-if="(this.$router.currentRoute.name === 'animer') && !boardIsClosed"
              >
                <b-tooltip
                  type="is-primary"
                  :label="$t('tooltip.clock')"
                  position="is-left"
                >
                  <img
                    src="/static/emptyClock.png"
                    alt="Clock Icon"
                    class="iconPic"
                  >

                </b-tooltip>
              </div>
              <div
                class="fullscreenswitch weirdFlex"
                @click="prompt()"
                v-if="(this.$router.currentRoute.name === 'animer') && !boardIsClosed"
              >
                <b-tooltip
                  type="is-primary"
                  :label="$t('tooltip.announcement')"
                  position="is-left"
                >
                  <img
                    src="/static/emptyBullhorn.png"
                    alt="Bullhorn Icon"
                    class="iconPic"
                  >

                </b-tooltip>
              </div>
              <div
                class="fullscreenswitch weirdFlex"
                @click="toggleTrashCan"
                v-if="(this.$router.currentRoute.name === 'animer') && !boardIsClosed"
              >
                <b-tooltip
                  type="is-primary"
                  :label="$t('tooltip.trashcan')"
                  position="is-left"
                >
                  <img
                    src="/static/emptyTrashcan.png"
                    alt="Trashcan Icon"
                    class="iconPic"
                  >

                </b-tooltip>
              </div>
              <div
                v-if="(this.$router.currentRoute.name === 'animer') && (this.current.mode === 'moderee') && !boardIsClosed"
                class="queueswitch weirdFlex"
                @click="toggleQueue"
              >
                <b-tooltip
                  type="is-primary"
                  :label="$t('tooltip.queue')"
                  position="is-left"
                >
                  <h3
                    v-if="(currentBoardPostWaiting.length !== 0)"
                    class="badge"
                  >{{ currentBoardPostWaiting.length }}</h3>
                  <b-icon
                    class="queueicon myIcons"
                    custom-size="null"
                    custom-class="innerIcons"
                    pack="far"
                    icon="share-square"
                  ></b-icon>
                </b-tooltip>
              </div>
            </div>

          </span>
        </div>

        <sheetSelector></sheetSelector>
      </div>
    </div>
    <board
      ref="board"
      class="board"
      :hasFilteredColor="this.currentFilteredColor"
    ></board>
    <minimap></minimap>
    <ZoomButtons ref="zoomButtons" />
    <addPostButton
      v-if="!boardIsClosed"
      ref="addPostButton"
      :editing="this.$store.state.board.editing"
    ></addPostButton>
    <toolbar></toolbar>
    <b-modal :active.sync="editFolderActive">
      <EditFolderPopup :folder="editingFolder" />
    </b-modal>
    <b-field class="langchange">
      <b-select
        v-model="$i18n.locale"
        placeholder="Langue"
        icon="globe"
        icon-pack="fas"
        :input="onChange()"
        id="selectlangue"
      >
        <option
          v-for="(lang, i) in langs"
          :key="`Lang${i}`"
          :value="lang.val"
        >{{ lang.label }}</option>
      </b-select>
    </b-field>
    <div class="userCount">
      <b-icon
        class="fullscr"
        pack="fas"
        icon="user"
        size="is-small"
      ></b-icon>
      {{ $t('user.online') }} : {{ userConnectedToRoom }}
    </div>

    <div v-if="this.$router.currentRoute.name === 'animer'">
      <div v-if="this.current.mode === 'moderee'">
        <queue></queue>
      </div>
    </div>

    <div v-if="this.$router.currentRoute.name === 'animer'">
      <TrashCan></TrashCan>
    </div>

    <!-- <div v-if="this.$router.currentRoute.name === 'board'">
      <div v-bind:class="{modal: true, 'is-active': this.notif }">
        <div
          class="modal-background"
          @click="toggleNotif"
        ></div>
        <div class="modal-content">
          <div class="box bluebox">
            <b-icon
              @click="toggleNotif"
              pack="fas"
              icon="info-circle"
            ></b-icon>
            <p>
              <span v-html="$t('board.message.welcome')"></span>
            </p>
            <p v-if="this.current.mode === 'moderee'">
              <span v-html="$t('board.message.welcome.moderee')"></span>
            </p>
          </div>
        </div>
        <button
          class="modal-close is-large"
          aria-label="close"
          @click="toggleNotif"
        ></button>
      </div>
    </div> -->

    <div v-bind:class="{modal: true, 'is-active': screenshotShowed }">
      <div
        @click="popupScreenshotToggle"
        class="modal-background"
      ></div>
      <div
        class="modal-content"
        style="min-width: 320px;"
      >
        <div class="box">
          <img
            :src="screeshotImage"
            id="screen"
            alt="Screenshot"
          />
          <a
            :href="screeshotSVG"
            download="brainstormin_screenshot.svg"
          >
            <button
              class="button is-primary"
              style="width:200px;height: 60px;margin:5px;"
            >
              <b-icon
                class
                pack="fas"
                icon="download"
                size="is-small"
              ></b-icon>
              <span v-html="$t('button.telecharger.svg')"></span>
            </button>
          </a>
          <a
            :href="screeshotImage"
            download="brainstormin_screenshot.png"
          >
            <button
              class="button is-primary"
              style="width:200px;height: 60px;margin:5px;"
            >
              <b-icon
                class
                pack="fas"
                icon="download"
                size="is-small"
              ></b-icon>
              <span v-html="$t('button.telecharger')"></span>
            </button>
          </a>
          <a
            :href="bgdownload"
            target="_blank"
            download="brainstormin_background.png"
          >
            <button
              class="button is-primary"
              style="width:200px; height: 60px;margin:5px;"
            >
              <b-icon
                class
                pack="fas"
                icon="download"
                size="is-small"
              ></b-icon>
              <span v-html="$t('button.telecharger.fond')"></span>
            </button>
          </a>
        </div>
      </div>
      <button
        @click="popupScreenshotToggle"
        class="modal-close is-large"
        aria-label="close"
      ></button>
    </div>
    <div v-bind:class="{modal: true, 'is-active': infoShowed }">
      <div
        @click="toggleInfos"
        class="modal-background"
      ></div>
      <div class="modal-content">
        <div class="box">
          <h2>
            <b>{{ $t('statistics.title') }}</b>
          </h2>
          <p>{{ $t('statistics.postnumber') }} : {{ currentBoardPost.filter(post => post.etat !== 'poubelle').length }}</p>
          <p>{{ $t('statistics.postnumberWaiting') }} : {{ currentBoardPostWaiting.length }}</p>
          <div
            v-for="(number, index) in colorCount"
            v-bind:key="index"
          >
            <p>
              <b-icon
                pack="fas"
                icon="square"
                size="is-small"
                :style="'color:'+index"
              ></b-icon>
              : {{ number }}
            </p>
          </div>
        </div>
      </div>
      <button
        @click="toggleInfos"
        class="modal-close is-large"
        aria-label="close"
      ></button>
    </div>
    <b-modal :active.sync="showClock">
      <Clock :id="current.id" />
    </b-modal>
  </div>
</template>

<script>
import Clock from './toolbar/Clock'
import board from './board'
import sheetSelector from './sheetSelector'
import EventBus from '../../EventBus'
import canvg from 'canvg'
import minimap from './minimap'
import backToAdmin from './backToAdmin'
import addPostButton from './addPostButton'
import toolbar from './toolbar/toolbar'
import queue from './queue'
import TrashCan from './TrashCan'
import ZoomButtons from './ZoomButtons'
import socketPing from '../socketTest/socketPing'
import EditFolderPopup from './modal/EditFolderPopup'

import { createNamespacedHelpers } from 'vuex'
const { mapState } = createNamespacedHelpers('board')

export default {
  name: 'BoardMeetingComponent',
  components: {
    TrashCan,
    ZoomButtons,
    Clock,
    board: board,
    socketPing: socketPing,
    addPostButton: addPostButton,
    toolbar: toolbar,
    backToAdmin: backToAdmin,
    queue: queue,
    minimap: minimap,
    sheetSelector: sheetSelector,
    EditFolderPopup
  },
  data: function () {
    return {
      announcement: {
        message: '',
        show: false
      },
      editingFolder: {},
      editFolderActive: false,
      colorPicking: false,
      showTools: true,
      drawingActive: false,
      arrowActive: false,
      erasingActive: false,
      writingActive: false,
      selectingActive: false,
      showClock: false,
      isFullscreen: false,
      notif: true,
      recherche: '',
      loaded: false,
      currentFilteredColor: null,
      userConnectedToRoom: 0,
      colorCount: {},
      bgdownload: '',
      colors: [],
      width: 8,
      lineColor: 'rgb(20,20,20)',
      screeshotImage: '',
      screeshotSVG: '',
      screenshotShowed: false,
      infoShowed: false,
      langs: [{ val: 'fr', label: "Français" }, { val: 'en', label: "English" }]
    }
  },
  computed: {
    insideIframe () {
      return this.$store.state.auth.insideIframe
    },
    ...mapState({
      isImageModalActive: 'isImageModalActive',
      ImageModalSrc: 'ImageModalSrc',
      current: 'current',
      currentSheet: 'currentSheet',
      currentBoardPostWaiting: 'currentBoardPostWaiting',
      menu: 'menu',
      folders: 'folders',
      currentBoardPost: 'currentBoardPost',
      boardIsClosed: "boardIsClosed"
    })
  },
  mounted () {    
    if (window.location !== window.parent.location) {
      this.$route.params.languageColidee = this.$store.getters["langue"];
      this.$i18n.locale = this.$route.params.languageColidee
    }
    this.height()
    this.$store.commit('board/ETAT_MENU', '')
    this.sendMessageToParent('scrollToTop')
    let message = {
      task: 'updateHeight',
      height: 900
    }
    window.top.postMessage(message, '*')
  },

  watch: {
    current: {
      handler: function (val) {
        // permet d'uploader le background
        if (this.currentSheet) {
          EventBus.$emit('UPLOAD_SHEET', this.currentSheet)
        }
        if (this.current.id !== undefined && this.loaded === false) {
          this.loaded = true
          var data = { board: this.current }
          if (this.current.template !== null) {
            this.bgdownload = process.env.URL_MEDIA + this.current.template.url
          }
          this.$store.dispatch('board/loadBoardData', data)
          this.$store.commit('board/SOCKET_STATE', {
            state: this.$socket.connected
          })
          var room = 'Room_Brain_' + this.current.id
          this.$socket.emit('room', room)
        }
        // console.log(this.colors)
        // this.colors = JSON.parse(this.current.colours)
        if (this.current.colours && typeof this.current.colours !== 'object') {
          this.colors = JSON.parse(this.current.colours)
        }
        while (typeof this.colors !== 'object') {
          this.colors = JSON.parse(this.colors)
        }
        if (!this.colors.includes('rgb(255,255,255)')) {
          this.colors.push('rgb(255,255,255)')
        }
        if (!this.colors.includes('rgb(20,20,20)')) {
          this.colors.push('rgb(20,20,20)')
        }
        // console.log(this.colors)
      },
      deep: true,
      immediate: true
    },
    recherche: {
      handler: function (val) {
        this.rechercheValue(val)
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    sendMessageToParent (taskToDo) {
      let message = {
        task: taskToDo
      }
      window.top.postMessage(message, '*')
    },
    closeImageModal () {
      this.$store.commit('board/SHOW_PICTURE', { url: '', open: false })
    },
    lockScreen () {
      this.$refs.board.lockScreen()
    },
    showColorPicker () {
      this.colorPicking = !this.colorPicking
      let colorSquare = document.querySelector('#currentColor')
      let colorPopup = document.querySelector('#colorPopupMenu')
      colorPopup.style.top = colorSquare.offsetTop + 20 + 'px'
      colorPopup.style.left = colorSquare.offsetLeft + 20 + 'px'
    },
    setToolDisplay () {
      this.showTools = !this.showTools
      this.height()
    },
    prompt () {
      this.sendMessageToParent('scrollToTop')
      this.$buefy.dialog.prompt({
        message: this.$i18n.t('prompt.sendWarn'),
        cancelText: this.$i18n.t('dialog.cancel'),
        confirmText: this.$i18n.t('dialog.send'),
        inputAttrs: {
          placeholder: 'Il reste X minutes'
        },
        trapFocus: true,
        onConfirm: message => {
          this.$socket.emit('sendWarn', 'Room_Brain_' + this.current.id, message)
        }
      })
    },
    changeColor (color) {
      this.colorPicking = false
      this.$refs.board.changeColor(color)
      this.lineColor = color
    },
    linkWithHierarchy () {
      if (this.menu.linkHier) {
        this.$store.commit('board/ETAT_MENU', '')
      } else {
        this.$store.commit('board/ETAT_MENU', 'linkHier')
      }

      this.lockScreen()
    },
    linkWithoutHierarchy () {
      if (this.menu.linkSimple) {
        this.$store.commit('board/ETAT_MENU', '')
      } else {
        this.$store.commit('board/ETAT_MENU', 'linkSimple')
      }

      this.lockScreen()
    },
    drawingOnOffClick () {
      if (this.menu.drawing) {
        this.$store.commit('board/ETAT_MENU', '')
      } else {
        this.$store.commit('board/ETAT_MENU', 'drawing')
      }

      this.lockScreen()
    },
    selectingOnOffClick () {
      if (this.menu.selecting) {
        this.$store.commit('board/ETAT_MENU', '')
      } else {
        this.$store.commit('board/ETAT_MENU', 'selecting')
      }

      this.lockScreen()
    },
    erasingOnOffClick () {
      if (this.menu.erasing) {
        this.$store.commit('board/ETAT_MENU', '')
      } else {
        this.$store.commit('board/ETAT_MENU', 'erasing')
      }

      this.lockScreen()
    },
    writingOnOffClick () {
      if (this.menu.modeWriting) {
        this.$store.commit('board/ETAT_MENU', '')
      } else {
        this.$store.commit('board/ETAT_MENU', 'modeWriting')
      }

      this.lockScreen()
    },
    height () {
      setTimeout(() => {
        document.querySelector('#positionning').style = ` height:${document.querySelector('#sheetselector').getBoundingClientRect().bottom}px;`
      }, 50)
    },
    rechercheValue (val) {
      this.currentFilteredColor = null
      var posts = document.getElementsByClassName('groupPostit')
      for (let x = 0; x < posts.length; x++) {
        var id = posts[x].getAttribute('id')
        id = parseInt(id.replace('postitnumber', ''))

        var post = this.$store.state.board.currentBoardPost.filter(
          p => p.id === id
        )[0]

        var str1 = post.contenu.toLowerCase()
        var str2 = val.toLowerCase()

        if (str1.indexOf(str2) === -1) {
          posts[x].setAttribute('opacity', 0.2)
        } else {
          posts[x].setAttribute('opacity', 1)
        }

        if (val.length === 0) {
          posts[x].setAttribute('opacity', 1)
        }
      }
    },
    filterColor (color) {
      this.recherche = '' // reset the search by words
      setTimeout(() => {
        this.currentFilteredColor = color
        var posts = document.getElementsByClassName('groupPostit')
        for (let x = 0; x < posts.length; x++) {
          var id = posts[x].getAttribute('id')
          id = parseInt(id.replace('postitnumber', ''))

          var post = this.$store.state.board.currentBoardPost.filter(
            p => p.id === id
          )[0]

          if (color !== null) {
            var str1 = post.couleur
            var str2 = color
            if (str1 !== str2) {
              posts[x].setAttribute('opacity', 0.2)
            } else {
              posts[x].setAttribute('opacity', 1)
            }
          } else {
            if (this.$refs.board.$refs.link && this.$refs.board.$refs.link.length > 0) {
              this.$refs.board.$refs.link.forEach(link => { link.opacity = 1 })
            }
            posts[x].style.cursor = 'grab'
            posts[x].childNodes[0].style.cursor = 'grab'
            posts[x].setAttribute('opacity', 1)
          }
        }
      }, 100)
    },
    toggleNotif () {
      this.notif = !this.notif
    },
    popupScreenshotToggle () {
      this.screenshotShowed = !this.screenshotShowed
    },
    toggleQueue () {
      this.$store.state.board.queueIsDisplayed = !this.$store.state.board.queueIsDisplayed
      this.$store.state.board.trashcanIsDisplayed = false
    },
    toggleTrashCan () {
      this.$store.state.board.trashcanIsDisplayed = !this.$store.state.board.trashcanIsDisplayed
      this.$store.state.board.queueIsDisplayed = false
    },
    toggleInfos () {
      this.colorCount = {}
      this.currentBoardPost.forEach(element => {
        if (!this.colorCount[element.couleur]) {
          this.colorCount[element.couleur] = 0
        }
        this.colorCount[element.couleur] += 1
      })
      this.infoShowed = !this.infoShowed
    },
    fullscreen () {
      var elem = document.documentElement

      if (!this.isFullscreen) {
        if (elem.requestFullscreen) {
          elem.requestFullscreen()
        } else if (elem.mozRequestFullScreen) {
          /* Firefox */
          elem.mozRequestFullScreen()
        } else if (elem.webkitRequestFullscreen) {
          /* Chrome, Safari and Opera */
          elem.webkitRequestFullscreen()
        } else if (elem.msRequestFullscreen) {
          /* IE/Edge */
          elem.msRequestFullscreen()
        }
      } else {
        if (document.exitFullscreen) {
          document.exitFullscreen()
        } else if (document.mozCancelFullScreen) {
          /* Firefox */
          document.mozCancelFullScreen()
        } else if (document.webkitExitFullscreen) {
          /* Chrome, Safari and Opera */
          document.webkitExitFullscreen()
        } else if (document.msExitFullscreen) {
          /* IE/Edge */
          document.msExitFullscreen()
        }
      }
      this.isFullscreen = !this.isFullscreen
    },
    screeshot () {
      var svg = document.querySelector('svg')
      var clonedsvg = svg.cloneNode(true)

      let ns = 'http://www.w3.org/2000/svg' //  recréer les dossiers en pur svg pour l'export d'image
      // console.log(this.folders)
      this.folders.forEach(folder => {
        let container = document.createElementNS(ns, 'g') // créer un groupe svg
        container.setAttribute('transform', `translate(${folder.coord_x} ${folder.coord_y})`) // positonné au meme endroit que le dossier

        let htmlFolder = document.querySelector('#folder' + folder.id) // on récupère le vrai dossier html sur la page

        if (htmlFolder && htmlFolder.getBoundingClientRect()) {
          let folderCoords = htmlFolder.getBoundingClientRect() // on garde les mesures du dossier html
          // console.log(htmlFolder)

          let background = document.createElementNS(ns, 'rect') // créer un fond pour le dossier svg

          background.setAttribute('height', folderCoords.height) // on stylise le fond
          background.setAttribute('width', folderCoords.width)
          background.setAttribute('rx', 5)
          background.setAttribute('x', 0)
          background.setAttribute('y', 0)
          background.setAttribute('fill', '#d2cdcd')

          let header = document.createElementNS(ns, 'rect') // on créé un ent^te similaire à celui html
          header.setAttribute('height', 31)
          header.setAttribute('width', folderCoords.width)
          header.setAttribute('rx', 5)
          header.setAttribute('x', 0)
          header.setAttribute('y', 0)
          header.setAttribute('fill', '#424a60')

          let headerText = document.createElementNS(ns, 'text') // on créé le texte de l'entete
          headerText.textContent = folder.name
          headerText.setAttribute('x', 8)
          headerText.setAttribute('y', 20)
          headerText.setAttribute('font-size', '11')
          headerText.setAttribute('fill', '#ffffff')
          headerText.setAttribute('stroke', '#ffffff')

          container.appendChild(background)
          container.appendChild(header)
          container.appendChild(headerText)

          if (folderCoords.width == '150') { // on regarde si le dossier est minimisé ou pas
            folder.posts.forEach((post, key) => {
              let dot = document.createElementNS(ns, 'circle') // si il l'est, on crée un point par post
              dot.setAttribute('cx', ((35 * (key % 4)) + 22.5)) // et on le stylise
              dot.setAttribute('cy', ((35 * Math.floor(key / 4)) + 22.5) + 31)
              dot.setAttribute('r', 12.5)
              dot.setAttribute('fill', post.couleur)
              // console.log(dot)
              container.appendChild(dot)
            })
          } else { // si il ne l'est pas, on copie le post
            folder.posts.forEach((post, key) => {
              let postSVG = document.querySelector('#postitnumber' + post.id).cloneNode(true)
              let coordX = 10 + (key % 2) * 265
              let coordY = 45 + Math.floor(key / 2) * 80
              postSVG.setAttribute('transform', `translate(${coordX} ${coordY})`)
              // console.log(postSVG)
              container.appendChild(postSVG)
            })
          }

          // console.log(container)
          clonedsvg.appendChild(container)
        }
      })

      clonedsvg.childNodes.forEach((element, index) => {
        if (
          element.tagName === 'g' &&
          element.getAttribute &&
          element.getAttribute('class') &&
          element.getAttribute('class').indexOf('hide') !== -1
        ) {
          element.setAttribute('opacity', 0)
        }
      })

      var serializer = new XMLSerializer()
      var svgString = serializer.serializeToString(clonedsvg)
      svgString = '<?xml version="1.0" standalone="no"?>\r\n' + svgString
      this.screeshotSVG =
        'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svgString)

      var postitCanvas = document.createElement('canvas')
      postitCanvas.width = 3840
      postitCanvas.height = 2160

      canvg(postitCanvas, svgString, {
        ignoreMouse: true,
        ignoreAnimation: true,
        ignoreClear: false
      })

      this.screeshotImage = postitCanvas.toDataURL('image/png', 1.0)

      this.popupScreenshotToggle()
    },
    wordcloud () {
      if (this.currentBoardPost.filter(post => post.etat == 'publie').length) {
        // this.$router.push({name: 'cloud', params: { url_participant: this.current.url_participant }})
        let routeData = this.$router.resolve({
          name: 'cloud',
          params: { url_participant: this.current.url_participant }
        })
        window.location = (routeData.href)
      } else {
        this.$buefy.toast.open({
          message: this.$i18n.t('wordcloud.creation.empty'),
          type: 'is-danger',
          position: 'is-bottom'
        })
      }
    },
    pagelike () {
      let routeData = this.$router.resolve({
        name: 'like',
        params: { url_participant: this.current.url_participant }
      })
      window.location = (routeData.href)
    },
    trashpage () {

    },
    onChange (event) {
      if (document.getElementById('selectlangue')) {
        var selectlangue = document.getElementById('selectlangue').value
        this.$store.dispatch('changeLangue', selectlangue)
      }
    }
  },
  sockets: {
    connect () {
      this.$store.commit('board/SOCKET_STATE', { state: true })
      if (this.current.id) {
        var room = 'Room_Brain_' + this.current.id

        this.$socket.emit('room', room)
      }
    },
    disconnect () {
      this.$store.commit('board/SOCKET_STATE', { state: false })
    },
    channel (data) {
      var decodeddata = JSON.parse(decodeURIComponent(data))
      if (decodeddata.type === 'CREATE') {
        this.$store.commit('board/NEW_POST', decodeddata.post)
      } else if (decodeddata.type === 'UPDATE') {
        this.$store.commit('board/UPDATE_POST', decodeddata.post)
      } else if (decodeddata.type === 'NEW_SHEET') {
        this.$store.commit('board/NEW_SHEET', decodeddata.post)
      } else if (decodeddata.type === 'DESTROY_SHEET') {
        this.$store.commit('board/REMOVE_SHEET', decodeddata.post)
      } else if (decodeddata.type === 'UPDATE_SHEET') {
        this.$store.commit('board/UPDATE_SHEET', decodeddata.post)
      }
    },
    count (data) {
      this.userConnectedToRoom = data
    },
    receiveWarn (data) {
      this.announcement.show = true
      this.announcement.message = data
    }
  }
}
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Open+Sans&display=swap");

#announcementCont {
  background: rgba(0, 0, 0, 0.6);
  position: fixed;
  width: 100vw;
  height: 100vh;
  z-index: 2;
}

#arrowOnOff {
  margin-top: 4px;
}

#drawingArrowHead {
  filter: invert(100%);
}
.weirdFlex {
  display: flex;
  justify-content: center;
  align-content: flex-end;
  flex-flow: column;
}

#announcement {
  position: fixed;
  z-index: 20;
  top: 45vh;
  right: 45vw;
  border: 3px #0b3c71 solid;
  padding: 40px;
  background: #424a60;
  color: white;
  font-weight: bolder;
  font-size: 1.2rem;
}

#currentColor {
  position: absolute;
  bottom: 4px;
  width: 17px;
  height: 17px;
  margin: auto 3px 0px;
}
#colorPopupMenu {
  display: flex;
  width: 80px;
  flex-flow: row wrap;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 10;
  background: #424a60;
  padding: 5px;
  border: 1px solid white;
}

#showToolbar {
  background-color: #424a60;
}

#widthSetter > input {
  width: 40px;
}
#widthSetter {
  height: min-content;
  margin-top: 11px;
  margin-left: -2px;
  padding-left: 6px;
}
.active {
  padding: 3px !important;

  box-shadow: inset 0px 0px 7px #000;
  outline: none;
  border: 1px solid #2a4868;
  border-radius: 3px;
  cursor: pointer;
}
#drawingColors {
  display: flex;
  flex-flow: row wrap;
  padding-left: 0px;
  padding-top: 2px;
  align-content: end;
  padding-bottom: 4px;
  width: 22px;
}

.colorBlock {
  border: 1px solid white;
  margin: 2px;
  width: 16px;
  height: 16px;
}
#bottomHalf {
  display: flex;
  flex-flow: row wrap;
  width: 100%;
  justify-content: space-between;
  padding: 0 15px 5px;
  margin-top: 0px;
}

.innerIcons {
  font-size: 16px !important;
  color: cyan !important;
}
.myIcons {
  /* height: 32px; */
  width: auto;
  font-size: 18px;
  cursor: pointer;
  color: white;
}
.leftIcon {
  margin-top: 6px;
  /* width: 0.8rem; */
}

#nuagePic {
  height: 24px;
  margin: 0px auto -4px;
}

.leftMenu {
  display: flex;
  flex-flow: row wrap;
  color: white;
  justify-content: center;
  align-content: center;
}
.langchange {
  z-index: 5;
  position: fixed;
  right: 0;
  bottom: 0;
  padding: 5px;
  margin: 20px 20px 55px 20px !important;
}
#screen {
  border: 2px solid black;
  margin: auto;
}
.bluebox {
  background-color: #424a60;
  color: white;
}
.notif {
  position: fixed;
  top: 0;
  left: 0;
  margin: 25px;
  z-index: 100;
  font-size: 18px;
  max-width: 400px;
}
.overlay {
  background-color: rgba(0, 0, 0, 0.6);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
  width: 100%;
  height: 100%;
}
.boardmeeting {
  position: absolute;
  height: 100%;
  width: 100%;
  overflow: scroll;
  -webkit-overflow-scrolling: touch;
  text-align: center;
}
.queue {
  position: fixed;
  color: black !important;
  bottom: 0;
  text-align: right;
  width: 100%;
  margin: 0 0 25px 0;
  padding-right: 30px;
  font-size: 30px;
}

.fullscreenswitch {
  vertical-align: top;
  margin: 0 0 0 0;
  cursor: pointer;
}
.queueswitch {
  vertical-align: top;
  margin: 0 0 0 0;
  cursor: pointer;
}

.title {
  color: white;
  float: left;
  margin: 0;
  font-size: 18px;
  margin: 0 0 0 5px !important;
  text-align: left;
  display: flex;
  word-break: normal;
}
.title > img {
  display: inline-block;
  vertical-align: top;
  height: 45px;
}
.title > h1 {
  font-family: "Open Sans";
  color: #e6ecf0;
  display: inline-block;
  padding: 0px 0 0 10px;
  width: 100%;
}
.recherche {
  padding: 5px;
  margin: 3px 0 -2px;
  border-radius: 0px;
}
.recherche > input {
  padding: 5px;
  width: 14vw;
  min-width: 100px;
  height: 28px;
  border: 1px solid white;
  border-radius: 0px;
}
.colorfilter {
  display: inline-block;
  vertical-align: top;
  margin: 0 0 0 0;
  height: 28px;
  padding-top: 5px;
}

.filterButton {
  background-color: white;
  color: grey;
}

.filterByColorText {
  margin-right: 20px;
}

.filterByColorText::after {
  content: " ";
  height: 0;
  position: absolute;
  color: black;
  top: 50%;
  right: 5px;
  width: 0;
  border: 6px solid rgba(0, 0, 0, 0);
  border-top-color: rgba(0, 0, 0, 0);
  border-top-color: #424a60 !important;
  margin-top: -3px;
  z-index: 1;
}

.leftMenuBtn {
  padding: 3px 3px !important;
  outline: none;
  border: 1px solid #424a60;
  border-radius: 3px;
  display: flex;
  flex-flow: column;
  justify-content: end;
}

#fixingDiv {
  z-index: 9;
  position: fixed;
}
.tools {
  width: 100vw;
  z-index: 9;
  top: 0;
  left: 0;
  background-color: #424a60;
  border-radius: 0;
  padding: 0px 5px 0px;
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  flex: 1;
  align-items: flex-start;
}
.tools > div {
  margin-top: 10px;
}
.rightMenu {
  display: flex;
  text-align: right;
  vertical-align: top;
  flex-flow: row wrap;
  margin-right: 5px;
  margin-left: auto;
  justify-content: center;
}

.rightMenu > * {
  margin: 4px 3px 0px;
  padding: 7px 0 0;
  text-align: center;
}

.tooltip.is-primary::after {
  background-color: #4da2e2;
}

.badge {
  position: absolute;
  background-color: #fc3a3a;
  border-radius: 50px;
  width: 20px;
  height: 20px;
  color: white;
  font-size: 14px;
  margin: -3px 0 0 -4px;
  text-align: center;
}
.queueicon,
.queueicon > i {
  color: white;
  font-weight: 100 !important;
}

.iconPic {
  height: 18px;
  margin: auto auto 0px;
}

.userCount {
  z-index: 5;
  position: fixed;
  right: 0;
  bottom: 0;
  color: white;
  background-color: #424a60;
  padding: 5px;
  margin: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/board/boardMeetingComponent.vue